<template>
    <div id="deliverydatedetailsPage">
        <div>
            <div class="top-buttons">
                <ui5-button @click="loadOther(-1, 'vorige')">
                    «
                    {{
                        trans(
                            'pages.delivery_date_details.buttons.previous_ride'
                        )
                    }}
                </ui5-button>
                <ui5-button @click="$router.go('-1')">
                    {{ trans('pages.delivery_date_details.buttons.back') }}
                </ui5-button>
                <ui5-button @click="$router.push('/deliverydates')">
                    {{
                        trans('pages.delivery_date_details.buttons.to_overview')
                    }}
                </ui5-button>
                <ui5-button
                    @click="$router.push('/editdeliverydate/' + dateId)"
                >
                    {{ trans('pages.delivery_date_details.buttons.edit_ride') }}
                </ui5-button>
                <ui5-button @click="exportDeliveryDateClick">
                    {{
                        trans('pages.delivery_date_details.buttons.export_ride')
                    }}
                </ui5-button>
                <ui5-button @click="exportDeliveryLists">
                    {{
                        trans(
                            'pages.delivery_date_details.buttons.export_delivery_notes'
                        )
                    }}
                </ui5-button>
                <ui5-button @click="exportDeliveryAddresses">
                    {{
                        trans(
                            'pages.delivery_date_details.buttons.export_addresses'
                        )
                    }}
                </ui5-button>
                <ui5-button @click="loadOther(1, 'volgende')">
                    {{ trans('pages.delivery_date_details.buttons.next_ride') }}
                    »
                </ui5-button>
            </div>
            <ui5-message-strip
                v-if="deliveryDate && deliveryDate.recurringConfigId && recurringPatternText"
                design="Information"
                class="recurring-info-strip"
            >
                <strong>{{ trans('pages.delivery_date_details.labels.recurring_pattern') }}</strong>
                {{ recurringPatternText }}
            </ui5-message-strip>
            <div class="row general-info">
                <div class="col-50">
                    <p>
                        <b>
                            {{
                                trans('pages.delivery_date_details.labels.date')
                            }}
                        </b>
                        <span
                            class="date"
                            v-if="deliveryDate"
                        >
                            {{ deliveryDate.date }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.driver'
                                )
                            }}
                        </b>
                        <span
                            class="driver"
                            v-if="deliveryDate && deliveryDate.driverDetails"
                        >
                            {{ deliveryDate.driverDetails.name }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.truck'
                                )
                            }}
                        </b>
                        <span
                            class="truck"
                            v-if="deliveryDate && deliveryDate.truckDetails"
                        >
                            {{ deliveryDate.truckDetails.name }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.delivery_method'
                                )
                            }}
                        </b>
                        <span
                            class="deliverymethod"
                            v-if="
                                deliveryDate &&
                                deliveryDate.deliveryMethodDetails
                            "
                        >
                            {{ deliveryDate.deliveryMethodDetails.name }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.region'
                                )
                            }}
                        </b>
                        <span
                            class="description"
                            v-if="deliveryDate"
                        >
                            {{ deliveryDate.description }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans('pages.delivery_date_details.labels.full')
                            }}
                        </b>
                        <span
                            class="full"
                            v-if="deliveryDate"
                        >
                            {{
                                deliveryDate.full == 0
                                    ? trans(
                                          'pages.delivery_date_details.yes_no.no'
                                      )
                                    : trans(
                                          'pages.delivery_date_details.yes_no.yes'
                                      )
                            }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.description'
                                )
                            }}
                        </b>
                        <span
                            class="fulldescription"
                            v-if="deliveryDate"
                        >
                            {{ deliveryDate.fullDescription }}
                        </span>
                    </p>
                    <p>
                        <b>
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.google_url'
                                )
                            }}
                        </b>
                        <span
                            class="url"
                            v-if="deliveryDate"
                            @click="openGoogleUrl"
                        >
                            {{ deliveryDate.url }}
                        </span>
                    </p>
                    <p v-if="deliveryDate && bingMapsLink">
                        <a
                            id="deliveryMapUrl"
                            :href="bingMapsLink"
                            @click="openBingMapsLink"
                        >
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.bing_maps'
                                )
                            }}
                        </a>
                    </p>
                    <div>
                        <ui5-button
                            @click="ordersDeliveredEvent"
                            v-if="isSuperAdmin"
                        >
                            {{
                                trans(
                                    'pages.delivery_date_details.labels.orders_delivered'
                                )
                            }}
                        </ui5-button>
                        <ui5-button
                            @click="toggleAllCustomers"
                            id="toggleAllCustomers"
                        >
                            {{
                                allCustomerToggle
                                    ? trans(
                                          'pages.delivery_date_details.labels.toggle_customers.expand'
                                      )
                                    : trans(
                                          'pages.delivery_date_details.labels.toggle_customers.collapse'
                                      )
                            }}
                        </ui5-button>
                    </div>
                </div>
                <div
                    id="deliverydate-header"
                    class="col-50"
                >
                    <div
                        class="deliverydate-header-inner"
                        v-if="deliveryDate"
                    >
                        <p>
                            <b>
                                {{
                                    trans(
                                        'pages.delivery_date_details.header.total_product_minutes'
                                    )
                                }}
                            </b>
                            <span class="totalProductminutes">
                                {{ times.totalProductMinutes }}
                            </span>
                            min
                        </p>
                        <p>
                            <b>
                                {{
                                    trans(
                                        'pages.delivery_date_details.header.finished_product_minutes'
                                    )
                                }}
                            </b>
                            <span class="finishedProductminutes">
                                {{ times.finishedProductMinutes }}
                            </span>
                            min
                        </p>
                        <p>
                            <b>
                                {{
                                    trans(
                                        'pages.delivery_date_details.header.percentage_progress'
                                    )
                                }}
                            </b>
                            <span class="percentageProgress">
                                {{ times.percentageProgress.toFixed(2) }}
                            </span>
                            %
                        </p>
                        <p>
                            <b>
                                {{
                                    trans(
                                        'pages.delivery_date_details.header.finished_products'
                                    )
                                }}
                            </b>
                            <span class="finishedProducts">
                                {{ times.finishedProducts }}/{{
                                    times.allProducts
                                }}
                            </span>
                        </p>
                    </div>
                    <h1
                        class="ritnr"
                        v-if="deliveryDate"
                    >
                        {{ deliveryDate.key }}
                    </h1>
                    <div
                        id="product-status"
                        class="bol2"
                        v-if="deliveryDate"
                        :style="{
                            'background-color': deliveryDate.statusFinished
                                ? 'green'
                                : 'red',
                        }"
                    />
                </div>
            </div>
        </div>

        <draggable
            v-if="deliveryDate"
            tag="table"
            :list="deliveryDate.customers"
            handle=".drag-handle"
            class="customer-table"
            @change="customerSortChanged"
        >
            <template>
                <tr
                    v-if="
                        !deliveryDate.customers ||
                        deliveryDate.customers.length == 0
                    "
                >
                    <td colspan="3">
                        {{
                            trans(
                                'pages.delivery_date_details.table.no_customers'
                            )
                        }}
                    </td>
                </tr>
                <template v-else>
                    <tbody
                        v-for="customer in deliveryDate.customers"
                        :key="customer.customerId"
                        class="product-table-item-tr"
                        :class="{ 'hide-orders': !customer.showOrders }"
                        @click="customer.showOrders = !customer.showOrders"
                    >
                        <tr>
                            <td>
                                <div class="drag-handle">
                                    <i class="fa fa-bars"></i>
                                </div>
                                {{ customer.customerId }}
                            </td>
                            <td
                                colspan="3"
                                class="customer-name-cell"
                            >
                                {{ customer.customerName }}
                                <span>
                                    {{ customer.street || '?' }} -
                                    {{ customer.city || '?' }}
                                </span>
                            </td>
                            <td>{{ customer.numberOfProducts }}</td>
                            <td v-if="isDebug">{{ customer.sortValue }}</td>
                        </tr>
                        <template v-if="customer.showOrders">
                            <tr
                                v-if="
                                    !customer.orders ||
                                    customer.orders.length == 0
                                "
                            >
                                <td
                                    class="order-table-item-tr"
                                    colspan="3"
                                >
                                    {{
                                        trans(
                                            'pages.delivery_date_details.table.no_orders'
                                        )
                                    }}
                                </td>
                            </tr>
                            <template
                                v-else
                                v-for="order in customer.orders"
                            >
                                <tr
                                    class="order-table-item-tr"
                                    :key="'1.' + order.orderId"
                                >
                                    <td class="icons-cell">
                                        <div>
                                            <i
                                                class="material-icons"
                                                @click="goToOrder(order)"
                                            >
                                                search
                                            </i>
                                            <ui5-checkbox
                                                v-if="isSuperAdmin"
                                                :checked="order.selected"
                                                @click.stop="() => {}"
                                                @change="
                                                    order.selected =
                                                        $event.target.checked
                                                "
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        {{ order.orderId }} -
                                        {{ order.reference }} -
                                        {{ order.wfOrderConfirmation }}
                                        {{
                                            order.deliverydateId == dateId
                                                ? ''
                                                : ' - ' +
                                                  trans(
                                                      'pages.delivery_date_details.table.pickup'
                                                  )
                                        }}
                                    </td>
                                    <td>
                                        {{ order.insertDate }}
                                    </td>
                                    <td
                                        valign="center"
                                        align="center"
                                    >
                                        <template v-if="isSuperAdmin">
                                            <ui5-button
                                                @click="
                                                    customerClicked = customer;
                                                    $refs.schedulePopup.open(
                                                        order.orderId,
                                                        deliveryDate
                                                    );
                                                "
                                                :id="
                                                    'schedule-deliverydate-' +
                                                    customer.customerId
                                                "
                                            >
                                                {{
                                                    trans(
                                                        'pages.delivery_date_details.table.move_order'
                                                    )
                                                }}
                                            </ui5-button>
                                        </template>
                                    </td>
                                    <td>
                                        {{
                                            order.products
                                                ? order.products.length
                                                : 0
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    v-if="
                                        !order.products ||
                                        order.products.length == 0
                                    "
                                    :key="'2.' + order.orderId"
                                    class="product-table-item-tr-product"
                                >
                                    <td class="order-no-products">
                                        {{
                                            trans(
                                                'pages.delivery_date_details.table.no_products'
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    v-else
                                    v-for="product in order.products"
                                    :key="
                                        '3.' +
                                        order.orderId +
                                        '.' +
                                        product.productId
                                    "
                                    class="product-table-item-tr-product"
                                >
                                    <td class="icons-cell">
                                        <div>
                                            <i
                                                class="material-icons"
                                                @click="
                                                    $router.push(
                                                        '/editproduct/?orderId=' +
                                                            product.orderId +
                                                            '&productId=' +
                                                            product.productId +
                                                            '&productState=edit-product'
                                                    )
                                                "
                                            >
                                                search
                                            </i>
                                        </div>
                                    </td>
                                    <td colspan="2">
                                        {{ product.productNr }} -
                                        {{ product.producttypeName }} -
                                        {{ product.color.ralnr }}
                                        {{ product.color.raltype }}
                                    </td>
                                    <td>{{ product.reference }}</td>
                                    <td>{{ product.productstatus }}</td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </template>
            </template>
            <thead slot="header">
                <!-- This only works at the end of the draggable element for some reason -->
                <tr class="product-table-header-tr">
                    <th
                        slot="columns"
                        :popin-text="
                            trans(
                                'pages.delivery_date_details.table.headers.id'
                            )
                        "
                        class="product-table-header-td"
                    >
                        <span>
                            {{
                                trans(
                                    'pages.delivery_date_details.table.headers.id'
                                )
                            }}
                        </span>
                    </th>
                    <th
                        colspan="3"
                        slot="columns"
                        :popin-text="
                            trans(
                                'pages.delivery_date_details.table.headers.customer'
                            )
                        "
                        class="product-table-header-td"
                    >
                        <span>
                            {{
                                trans(
                                    'pages.delivery_date_details.table.headers.customer'
                                )
                            }}
                        </span>
                    </th>
                    <th
                        slot="columns"
                        :popin-text="
                            trans(
                                'pages.delivery_date_details.table.headers.products_count'
                            )
                        "
                        class="product-table-header-td"
                    >
                        <span>
                            {{
                                trans(
                                    'pages.delivery_date_details.table.headers.products_count'
                                )
                            }}
                        </span>
                    </th>
                    <th v-if="isDebug">
                        {{
                            trans(
                                'pages.delivery_date_details.table.headers.sort_value'
                            )
                        }}
                    </th>
                </tr>
            </thead>
        </draggable>

        <schedule-delivery-date-popup
            ref="schedulePopup"
            :title="trans('pages.delivery_date_details.popup.schedule_ride')"
            :on-confirm="onConfirmDeliveryDate"
            :new-delivery-date="newDeliveryDate"
            :deliveryroute="customerClickedDeliveryRoute"
        />
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { exportDeliveryDate, jaNeeToBool } from '../shared/deliveryDates';
import api from './../api/deliveryDates';
import IdParamMixin from '../mixins/id-param';
import isDebugMixin from '../mixins/is-debug';
import ScheduleDeliveryDatePopup from '../components/deliveryDates/ScheduleDeliveryDatePopup';
import orderApi from '../api/order';
import {
    showConfirmDialog,
    showErrorMessage,
    showInfoMessage,
} from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), isDebugMixin, localization],
    components: {
        draggable,
        ScheduleDeliveryDatePopup,
    },
    data() {
        return {
            dateId: null,
            deliveryDate: null,
            allCustomerToggle: false,
            customerClicked: null,
        };
    },
    computed: {
        clickedOffset: {
            get() {
                return this.$store.getters['deliveryDates/getOffsetClicked'];
            },
            set(value) {
                this.$store.commit('deliveryDates/setOffsetClicked', value, {
                    root: true,
                });
            },
        },
        bingMapsLink() {
            if (
                !this.deliveryDate ||
                !this.deliveryDate.customers ||
                this.deliveryDate.customers.length == 0
            ) {
                return '';
            }

            const eosol = 'adr.Smederijstraat 23, 2900 Schoten, Belgium';

            const customerAddresses = this.deliveryDate.customers
                .filter((customer) => {
                    // Only include customers with both street and city
                    return customer.street && customer.city;
                })
                .map((customer) => {
                    const street = customer.street;
                    const city = customer.city;
                    const country = customer.country || 'Belgium';
                    const bingPart = street + ', ' + city + ', ' + country;
                    return 'adr.' + bingPart;
                });

            const parts = [
                eosol,
                ...customerAddresses,
                eosol,
            ];

            return (
                'https://www.bing.com/maps/directions?rtp=' +
                parts.join('~')
            );
        },
        times() {
            const deliveryDateId = this.deliveryDate.id;

            let totalProductMinutes = 0;
            let finishedProductMinutes = 0;
            let finishedProducts = 0;
            let allProducts = 0;

            if (this.deliveryDate.customers) {
                this.deliveryDate.customers.forEach((customer) => {
                    if (customer.orders) {
                        customer.orders.forEach((order) => {
                            if (
                                order.products &&
                                order.pickupdateId != deliveryDateId
                            ) {
                                order.products.forEach((product) => {
                                    totalProductMinutes +=
                                        product.productionMinutes;

                                    if (
                                        this.deliveryDate.finishedStatusCodes.includes(
                                            product.productstatus
                                        )
                                    ) {
                                        finishedProductMinutes +=
                                            product.productionMinutes;
                                        finishedProducts++;
                                    }

                                    allProducts++;
                                });
                            }
                            order.selected = false;
                        });
                    }
                });
            }

            const percentageProgress =
                totalProductMinutes == 0
                    ? 0
                    : (finishedProductMinutes / totalProductMinutes) * 100;

            return {
                totalProductMinutes,
                finishedProductMinutes,
                percentageProgress,
                finishedProducts,
                allProducts,
            };
        },
        sessionStorage() {
            return sessionStorage;
        },
        isSuperAdmin() {
            return this.$store.getters['currentUser/hasRight'](
                'administration'
            );
        },
        selectedOrders() {
            if (!this.deliveryDate || !this.deliveryDate.customers) {
                return [];
            }
            const selected = [];
            this.deliveryDate.customers.forEach((customer) => {
                if (customer.orders) {
                    customer.orders.forEach((order) => {
                        if (order.selected) {
                            selected.push(order);
                        }
                    });
                }
            });
            return selected;
        },
        recurringPatternText() {
            if (!this.deliveryDate || !this.deliveryDate.recurringConfigId) {
                return '';
            }

            const config = this.deliveryDate.recurringConfig || {};
            if (!config.frequencyInterval || !config.daysOfWeek) {
                return '';
            }

            // Map day numbers to translation keys
            const dayMap = {
                1: this.trans('pages.recurring.day_mon'),
                2: this.trans('pages.recurring.day_tue'),
                3: this.trans('pages.recurring.day_wed'),
                4: this.trans('pages.recurring.day_thu'),
                5: this.trans('pages.recurring.day_fri'),
                6: this.trans('pages.recurring.day_sat'),
                7: this.trans('pages.recurring.day_sun')
            };

            // Parse days of week
            const days = config.daysOfWeek.split(',').map(d => dayMap[parseInt(d)]).filter(Boolean);
            const daysText = days.join(', ');

            // Format frequency with pluralization
            const count = parseInt(config.frequencyInterval);
            const frequencyKey = 'pages.delivery_date_details.labels.recurring_every_n_weeks';
            const frequencyParts = this.trans(frequencyKey, { count }).split('|');
            const frequencyText = count === 1 ? frequencyParts[0] : frequencyParts[1];

            // Build the full pattern text
            let parts = [frequencyText];

            if (daysText) {
                parts.push(this.trans('pages.delivery_date_details.labels.recurring_on_days', { days: daysText }));
            }

            // Add end date info
            if (config.endDate) {
                parts.push(this.trans('pages.delivery_date_details.labels.recurring_until', { date: config.endDate }));
            } else {
                parts.push('(' + this.trans('pages.delivery_date_details.labels.recurring_no_end') + ')');
            }

            return parts.join(' ');
        },
        customerClickedDeliveryRoute() {
            return this.customerClicked?.customerFields?.Leverrondes?.selectedOptionLabel ?? null;
        },
    },
    methods: {
        openBingMapsLink(e) {
            if (this.bingMapsLink) {
                window.open(this.bingMapsLink, '_blank');
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        },
        customerSortChanged() {
            this.$nextTick(() => {
                api.updateDeliverySorting(
                    this.dateId,
                    this.deliveryDate.customers.map((x) => x.customerId)
                )
                    .then((response) => {
                        //
                    })
                    .catch((error) => {
                        console.error('error', error);
                    });
            });
        },
        shouldWarnFirst(order) {
            const products = order.products || [];
            return products.some((product) => {
                return !this.deliveryDate.finishedStatusCodes.includes(
                    product.productstatus
                );
            });
        },
        goToOrder(order) {
            this.$router.push(
                '/editproduct/?orderId=' +
                    order.orderId +
                    '&productState=show-producttype'
            );
        },
        loadProductsForDelivery() {
            api.dateAndProducts(this.dateId).then((response) => {
                const deliveryDate = response.data.data;

                if (deliveryDate.customers) {
                    deliveryDate.customers.forEach((customer) => {
                        customer.showOrders = true;
                        if (customer.orders) {
                            customer.orders.forEach((order) => {
                                order.selected = false;
                            });
                        }
                    });
                }
                this.deliveryDate = deliveryDate;

                const title = this.trans(
                    'pages.delivery_date_details.methods.customer_overview_title',
                    { key: deliveryDate.key || '' }
                );
                this.$store.commit('general/setPageTitle', title, {
                    root: true,
                });
            });
        },
        markOrdersAsDelivered(orders) {
            api.markDelivered(
                this.$store.getters['currentUser/getUserId'],
                orders
            )
                .then((response) => {
                    this.loadProductsForDelivery();
                })
                .catch((error) => {
                    console.error('error', error);
                    showErrorMessage(
                        this.trans(
                            'pages.delivery_date_details.methods.mark_orders_error'
                        )
                    );
                });
        },
        ordersDeliveredEvent() {
            let warnFirst = false;
            const orders = this.selectedOrders.map((order) => {
                if (this.shouldWarnFirst(order)) {
                    warnFirst = true;
                }
                return order.orderId;
            });

            if (orders && orders.length > 0) {
                showConfirmDialog({
                    title: this.trans(
                        'pages.delivery_date_details.methods.mark_as_delivered.title'
                    ),
                    content: this.trans(
                        'pages.delivery_date_details.methods.mark_as_delivered.confirm_message'
                    ),
                    confirm: (dialog) => {
                        dialog.close();

                        if (warnFirst) {
                            showConfirmDialog({
                                title: this.trans(
                                    'pages.delivery_date_details.methods.mark_as_delivered.title'
                                ),
                                content: this.trans(
                                    'pages.delivery_date_details.methods.mark_as_delivered.unfinished_products'
                                ),
                                confirm: (dialog) => {
                                    dialog.close();
                                    this.markOrdersAsDelivered(orders);
                                },
                                cancel(dialog) {
                                    dialog.close();
                                },
                                confirmButton: this.trans(
                                    'pages.delivery_date_details.methods.mark_as_delivered.yes'
                                ),
                                cancelButton: this.trans(
                                    'pages.delivery_date_details.methods.mark_as_delivered.no'
                                ),
                            });
                        } else {
                            this.markOrdersAsDelivered(orders);
                        }
                    },
                    cancel(dialog) {
                        dialog.close();
                    },
                    confirmButton: this.trans(
                        'pages.delivery_date_details.methods.mark_as_delivered.yes'
                    ),
                    cancelButton: this.trans(
                        'pages.delivery_date_details.methods.mark_as_delivered.no'
                    ),
                });
            }
        },
        openGoogleUrl() {
            window.open(this.deliveryDate.url || '', '_blank');
        },
        exportDeliveryAddresses() {
            window.open(
                Config.url +
                    '/export/exportDeliveryDateAddresses/?deliveryDateId=' +
                    this.dateId
            );
        },
        exportDeliveryLists() {
            exportDeliveryDate(this.dateId, true);
        },
        exportDeliveryDateClick() {
            exportDeliveryDate(this.dateId, false);
        },
        loadOther(modification, name) {
            //Load the filters from the overview page into a payload
            const filters = this.$store.getters['deliveryDates/getFilters'];

            let clickedOffset = this.clickedOffset;
            if (clickedOffset < 0) {
                clickedOffset = 0;
            }
            const payload = {
                ...filters,
                deliverdatefull: jaNeeToBool(filters.deliverdatefull),
                //Take ~10 before and after just in case some deliveries are removed
                limit: 20,
                offset: clickedOffset - 10,
            };

            if (payload.offset < 0) {
                payload.offset = 0;
            }

            api.fetchOverview(payload).then((response) => {
                const deliveryDates = response.data.data;
                const comparison = this.deliveryDate.key;
                const indexInData = deliveryDates.findIndex(
                    (x) => x.key == comparison
                );

                //Take the previous or next item in the data
                const other = deliveryDates[indexInData + modification] || null;

                if (!other) {
                    return showErrorMessage(
                        this.trans(
                            'pages.delivery_date_details.methods.no_ride',
                            { name }
                        )
                    );
                }

                this.clickedOffset = clickedOffset + modification;
                this.$router.push('/deliverydatedetails/' + other.id);
            });
        },
        toggleAllCustomers() {
            const value = this.allCustomerToggle;

            if (this.deliveryDate && this.deliveryDate.customers) {
                this.deliveryDate.customers.forEach((customer) => {
                    customer.showOrders = value;
                });
            }

            this.allCustomerToggle = !value;
        },
        load() {
            this.dateId = this.$route.params.id;
            this.$store.commit(
                'deliveryDates/setLastClicked',
                this.$route.params.id,
                { root: true }
            );
            this.loadProductsForDelivery();
        },
        onConfirmDeliveryDate(deliveryDate, productionDate, button, orderId) {
            button.disabled = true;
            const deliveryDateId = deliveryDate.id;
            orderApi
                .setDeliveryDate(orderId, deliveryDateId)
                .then(() => {
                    return orderApi.setProductionDate(orderId, productionDate);
                })
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.delivery_date_details.methods.recalculating'
                        )
                    );
                    this.$refs.schedulePopup.close();
                    this.load();
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.delivery_date_details.methods.scheduling_error'
                        )
                    );
                })
                .finally(() => {
                    button.disabled = false;
                });
        },
        newDeliveryDate() {
            const customer = {
                customerNumber: this.customerClicked.customerId,
                customerName: this.customerClicked.customerName,
            };
            this.$router.push(
                '/adddeliverydate?customerForDeliveryDate=' +
                    JSON.stringify(customer)
            );
        },
    },
};
</script>
